import React, { useState, useEffect } from 'react';
import { Switch, Card, Divider, Spin } from 'antd';
import { fetchReminderSettings, updateReminderSettings } from 'api/calendarSetting';
import { ReminderSettings } from 'types/calendarSetting';
import s from './s.module.less';

const RemindersPage = () => {
    const [reminderSettings, setReminderSettings] = useState<ReminderSettings>({
        reminder1HoursBefore: true,
        reminder6HoursBefore: true,
        reminder24HoursBefore: true,
        reminder48HoursBefore: true,
        emailConfirmationAfterBooking: true,
        blockNextDayBooking: false,
        blockSameDayBooking: false,
        minAdvanceBookingHours: 0,
    });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const getReminderData = async () => {
            setLoading(true);
            try {
                const data = await fetchReminderSettings();
                if (data?.data?.data) {
                    setReminderSettings(data.data.data);
                }
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };
        getReminderData();
    }, []);

    const handleSwitchChange = (key: keyof typeof reminderSettings) => async (checked: boolean) => {
        const data = {
            ...reminderSettings,
            [key]: checked,
        };
        setReminderSettings(data);
        try {
            await updateReminderSettings(data);
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <Spin spinning={loading}>
            <div className={s.reminderContainer}>
                <Card className={s.reminderCard}>
                    <div className={s.sectionHeader}>
                        <p className={s.sectionTitle}>Email reminders for patients</p>
                        <Divider />
                        <p className={s.sectionDescription}>
                            Schedule automated email reminders to patients before their appointments
                        </p>
                    </div>

                    <div className={s.optionsList}>
                        <div className={s.reminderOption}>

                            <Switch
                                checked={reminderSettings.reminder48HoursBefore}
                                onChange={handleSwitchChange('reminder48HoursBefore')}
                                className={s.switchControl}
                            />
                            <span className={s.optionText}>48 hours before</span>
                        </div>

                        <div className={s.reminderOption}>
                            <Switch
                                checked={reminderSettings.reminder24HoursBefore}
                                onChange={handleSwitchChange('reminder24HoursBefore')}
                                className={s.switchControl}
                            />
                            <span className={s.optionText}>24 hours before</span>
                        </div>

                        <div className={s.reminderOption}>
                            <Switch
                                checked={reminderSettings.reminder6HoursBefore}
                                onChange={handleSwitchChange('reminder6HoursBefore')}
                                className={s.switchControl}
                            />
                            <span className={s.optionText}>6 hours before</span>
                        </div>

                        <div className={s.reminderOption}>
                            <Switch
                                checked={reminderSettings.reminder1HoursBefore}
                                onChange={handleSwitchChange('reminder1HoursBefore')}
                                className={s.switchControl}
                            />
                            <span className={s.optionText}>1 hours before</span>
                        </div>
                    </div>
                </Card>

                <Card className={s.reminderCard}>
                    <div className={s.sectionHeader}>
                        <p className={s.sectionTitle}>Appointment confirmation</p>
                        <Divider />
                        <p className={s.sectionDescription}>
                            Patients will receive an email confirmation after booking an appointment
                        </p>
                    </div>

                    <div className={s.optionsList}>
                        <div className={s.reminderOption}>
                            <Switch
                                checked={reminderSettings.emailConfirmationAfterBooking}
                                className={s.switchControl}
                                disabled
                            />
                            <span className={s.optionText}>Appointment email confirmation</span>
                        </div>
                    </div>
                </Card>
            </div>
        </Spin>
    );
};

export default RemindersPage;
